"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRedux = require("react-redux");
var _RequestProvider = require("../../providers/RequestProvider.js");
var _index = require("../../actions/index.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PreviewHover = _styledComponents.default.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  &:hover {
    background: rgba(140, 140, 140, 0.4);
    cursor: pointer;
  }
  .component-preview-mouseover & {
    background: rgba(140, 140, 140, 0.4);
  }
`;
const Component = props => {
  const {
    className,
    data: {
      type,
      delta
    },
    req: {
      flowPreview = false,
      hydrated = false,
      flowComponentFocused = -1,
      flowComponentHighlighted = -1
    },
    children
  } = props;
  const attr = {
    className,
    'data-type': type
  };
  if (flowPreview && hydrated) {
    const dispatch = (0, _reactRedux.useDispatch)();
    const compRef = /*#__PURE__*/_react.default.createRef();
    (0, _react.useEffect)(() => {
      if (flowComponentFocused === delta) {
        const node = compRef.current;
        document.documentElement.scrollTop = node.offsetTop;
        dispatch({
          type: _index.COMPONENT_CLICK_RECEIVED,
          value: -1
        });
      }
    }, [flowComponentFocused]);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, attr, {
      onMouseDown: () => dispatch({
        type: _index.COMPONENT_CLICK,
        value: {
          delta
        }
      }),
      onMouseEnter: () => dispatch({
        type: _index.COMPONENT_HOVER,
        value: {
          delta
        }
      }),
      onMouseLeave: () => dispatch({
        type: _index.COMPONENT_HOVER,
        value: {
          delta: -1
        }
      }),
      ref: compRef
    }), /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewHover, null), children));
  }
  return /*#__PURE__*/_react.default.createElement("div", attr, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, flowPreview && /*#__PURE__*/_react.default.createElement(PreviewHover, null), children));
};
var _default = exports.default = (0, _styledComponents.default)((0, _RequestProvider.withRequest)(Component))`
  position: relative;
`;